import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import _ from "lodash";
import axiosInstance from "../../config/axiosInterceptor";

const animCSS = `
@keyframes fadeInRow {
  0% { opacity: 0; transform: translateY(25px);}
  100% { opacity: 1; transform: translateY(0);}
}
@keyframes popBtn {
  0% { transform: scale(1);}
  40% { transform: scale(0.94);}
  100% { transform: scale(1);}
}
@keyframes spin {
  to { transform: rotate(360deg);}
}
`;

const UsernameHistory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASEURL1;
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [historyData, setHistoryData] = useState([]);
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getHistory = async (page, limit, searchValue = "") => {
    setHistoryData([]);
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(
        `/admin/usernameHistory/getUsernameHistory`,
        {
          page: page,
          limit: limit,
          search: searchValue
        }
      );
      if (response.data.success === 1) {
        setHistoryData(response.data.data);
        setCount(response.data.pagination.totalRecords);
        setTotalPages(response.data.pagination.totalPages);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHistory(currentPage, entriesPerPage);
    // eslint-disable-next-line
  }, [currentPage, entriesPerPage]);

  const handlePagination = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearchChange = useCallback(
    _.debounce((value) => {
      setCurrentPage(1);
      getHistory(1, entriesPerPage, value);
    }, 300),
    [entriesPerPage]
  );

  const handleSearchClick = () => {
    setCurrentPage(1);
    getHistory(1, entriesPerPage, search);
  };

  const clearSearch = () => {
    setSearch("");
    setCurrentPage(1);
    getHistory(1, entriesPerPage, "");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const tableRowAnim = (idx) => ({
    animation: `fadeInRow 0.6s ${(idx + 1) * 60}ms both`
  });

  return (
    <>
      <style>{animCSS}</style>
      <section className="content-header" style={{ margin: "22px 0 14px 0", padding: "0 18px" }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: "#1677ff", display: "flex", alignItems: "center", gap: 12 }}>
          Username Change History
          <span style={{ fontSize: 15, color: "#888", fontWeight: 600 }}>
            Track all username modifications
          </span>
        </h1>
        <ol className="breadcrumb" style={{
          background: "transparent", padding: 0, margin: 0, fontSize: 14
        }}>
          <li>
            <Link to="/admin/dashboard" style={{ color: "#1677ff" }}>
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active" style={{ color: "#888" }}>Username History</li>
        </ol>
      </section>

      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-md-12">
                <div className="row" style={{ padding: "16px 0px", display: "flex", flexWrap: "wrap", gap: 18 }}>
                  <div className="entries-per-page col-md-4">
                    <label htmlFor="entries" style={{ fontWeight: 600, color: "#555" }}>
                      Entries per page:
                    </label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={(e) => {
                        setEntriesPerPage(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                      style={{
                        marginLeft: 8,
                        borderRadius: 6,
                        border: "1.2px solid #b8daff",
                        fontSize: 15,
                        padding: "6px 15px",
                        outline: "none"
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div className="col-md-4" style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
                    <div className="main-data-single-field" style={{ width: "fit-content" }}>
                      <span style={{ fontWeight: "bold", marginRight: "8px" }}>Search Username</span>
                      <input
                        type="text"
                        id="searchUsername"
                        name="searchUsername"
                        style={{
                          borderRadius: "5px",
                          border: "1.2px solid #b8daff",
                          width: "200px",
                          fontSize: 15,
                          padding: "6px 12px"
                        }}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Exact username"
                      />
                    </div>
                    <button
                      style={{
                        border: "none",
                        borderRadius: 6,
                        fontWeight: 600,
                        background: "#1677ff",
                        color: "#fff",
                        padding: "7px 22px",
                        fontSize: 15,
                        boxShadow: "0 1px 6px #1677ff22",
                        cursor: "pointer",
                        animation: "popBtn 0.18s"
                      }}
                      onClick={handleSearchClick}
                    >
                      Search
                    </button>
                    {search && (
                      <button
                        style={{
                          border: "none",
                          borderRadius: 6,
                          fontWeight: 600,
                          background: "#6c757d",
                          color: "#fff",
                          padding: "7px 22px",
                          fontSize: 15,
                          boxShadow: "0 1px 6px #6c757d22",
                          cursor: "pointer",
                          animation: "popBtn 0.18s"
                        }}
                        onClick={clearSearch}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <table className="table table-hover table-striped" style={{
                  borderRadius: 10,
                  overflow: "hidden",
                  boxShadow: "0 4px 18px #1677ff0a"
                }}>
                  <thead style={{
                    background: "linear-gradient(90deg, #1677ff 0%, #52c41a 100%)",
                    color: "#fff"
                  }}>
                    <tr>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>#</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>User</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>Old Username</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>New Username</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>Current Username</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>Changed At</th>
                      <th style={{ padding: "15px 20px", fontSize: 16, fontWeight: 700 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center", padding: "50px" }}>
                          <i className="fa fa-spinner fa-spin" style={{ fontSize: 40, color: "#1677ff" }}></i>
                          <div style={{ marginTop: 10, color: "#888" }}>Loading...</div>
                        </td>
                      </tr>
                    ) : historyData.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center", padding: "50px", color: "#888" }}>
                          No username history found
                        </td>
                      </tr>
                    ) : (
                      historyData.map((item, idx) => (
                        <tr key={item._id} style={tableRowAnim(idx)}>
                          <td style={{ padding: "15px 20px", fontSize: 15 }}>
                            {(currentPage - 1) * entriesPerPage + idx + 1}
                          </td>
                          <td style={{ padding: "15px 20px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <img
                                src={item.picture || `${baseUrl}/default-avatar.png`}
                                alt={item.name}
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "2px solid #1677ff22"
                                }}
                              />
                              <div>
                                <div style={{ fontWeight: 600, fontSize: 15 }}>{item.name}</div>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "15px 20px" }}>
                            <span style={{
                              background: "#fff2f0",
                              color: "#ff4d4f",
                              padding: "4px 12px",
                              borderRadius: 6,
                              fontSize: 14,
                              fontWeight: 600
                            }}>
                              {item.oldUsername}
                            </span>
                          </td>
                          <td style={{ padding: "15px 20px" }}>
                            <span style={{
                              background: "#f6ffed",
                              color: "#52c41a",
                              padding: "4px 12px",
                              borderRadius: 6,
                              fontSize: 14,
                              fontWeight: 600
                            }}>
                              {item.newUsername}
                            </span>
                          </td>
                          <td style={{ padding: "15px 20px" }}>
                            <span style={{
                              background: "#e6f7ff",
                              color: "#1677ff",
                              padding: "4px 12px",
                              borderRadius: 6,
                              fontSize: 14,
                              fontWeight: 700
                            }}>
                              {item.currentUsername}
                            </span>
                          </td>
                          <td style={{ padding: "15px 20px", fontSize: 14, color: "#666" }}>
                            {formatDate(item.changedAt)}
                          </td>
                          <td style={{ padding: "15px 20px" }}>
                            <Link
                              to={`/admin/ViewUser?id=${item.userId}`}
                              style={{
                                background: "#1677ff",
                                color: "#fff",
                                padding: "6px 16px",
                                borderRadius: 6,
                                fontSize: 14,
                                fontWeight: 600,
                                textDecoration: "none",
                                display: "inline-block",
                                boxShadow: "0 2px 8px #1677ff22"
                              }}
                            >
                              View Profile
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-md-5">
                    <ul className="pagination" style={{
                      display: "flex",
                      gap: 8,
                      marginTop: 8
                    }}>
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                        style={{ display: "inline-block" }}
                      >
                        <button
                          onClick={() => handlePagination(currentPage - 1)}
                          className="page-link"
                          disabled={currentPage === 1}
                          style={{
                            background: currentPage === 1 ? "#e4eaf0" : "#1677ff",
                            color: currentPage === 1 ? "#888" : "#fff",
                            border: "none",
                            borderRadius: 7,
                            fontWeight: 700,
                            fontSize: 16,
                            padding: "7px 18px",
                            boxShadow: "0 1px 6px #1677ff1b",
                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                            transition: "background 0.17s"
                          }}
                        >
                          Previous
                        </button>
                      </li>
                      <li style={{ display: "inline-block", padding: "7px 15px", fontWeight: 700, color: "#555" }}>
                        Page {currentPage} of {totalPages}
                      </li>
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                        style={{ display: "inline-block" }}
                      >
                        <button
                          onClick={() => handlePagination(currentPage + 1)}
                          className="page-link"
                          disabled={currentPage === totalPages}
                          style={{
                            background: currentPage === totalPages ? "#e4eaf0" : "#1677ff",
                            color: currentPage === totalPages ? "#888" : "#fff",
                            border: "none",
                            borderRadius: 7,
                            fontWeight: 700,
                            fontSize: 16,
                            padding: "7px 18px",
                            boxShadow: "0 1px 6px #1677ff1b",
                            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                            transition: "background 0.17s"
                          }}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-7">
                    <div className="total-entries" style={{
                      float: "right",
                      marginTop: "20px",
                      color: "#234",
                      fontWeight: 700,
                      fontSize: 17
                    }}>
                      Total entries: <b>{count}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UsernameHistory;
